// Main entry point for Podium PWA
import { ApiService, apiService } from './services/api.js';
import { WebSocketService, websocketService } from './services/websocket.js';
import { AudioService, audioService } from './services/audio.js';
import { initializeAuth, authGuardService, googleAuthService } from './services/auth/index.js';
import { configService } from './services/config.js';

// Import podium-specific components
import './components/podium-app.js';
import './components/podium-session.js';
import './components/podium-past-sessions.js';
import './components/settings.js';

// Import styles
import './styles/main.css';
import './styles/polyglot.css';
import './styles/podium.css';

// Make services available globally
window.ApiService = ApiService;
window.apiService = apiService;
window.WebSocketService = WebSocketService;
window.websocketService = websocketService;
window.AudioService = AudioService;
window.audioService = audioService;
window.configService = configService;
window.authGuardService = authGuardService;
window.googleAuthService = googleAuthService;

// Initialize services
console.log('Podium entry point loaded - services available globally');

// Initialize authentication and then other services
async function initializeApp() {
  try {
    // Probe primary endpoint; fall back to secondary if unresponsive within 20s
    console.log('Resolving active backend endpoint...');
    const resolvedBackend = await configService.resolveActiveEndpoint();
    console.log('Backend resolved:', resolvedBackend, configService.getStatusInfo());

    // Initialize authentication
    console.log('Initializing authentication...');
    await initializeAuth();

    console.log('Authentication initialized successfully');

  } catch (error) {
    console.error('Failed to initialize app:', error);
    // Continue without auth for now, but log the error
  }
}

// Capture the install prompt for PWA installation
window.deferredPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent the default browser install prompt
  e.preventDefault();
  // Store the event for later use
  window.deferredPrompt = e;
  console.log('PWA install prompt captured and stored');
});

// Ensure DOM is ready before proceeding
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  initializeApp();
}
